import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import StatsBar from "./components/StatsBar";
import WhatWeOffer from "./components/WhatWeOffer";
import WhyChooseUs from "./components/WhyChooseUs";
import FeaturedWork from "./components/FeaturedWork";
import QuoteCTA from "./components/QuoteCTA";
import AreasCovered from "./components/AreasCovered";
import TestimonialsSnippet from "./components/TestimonialsSnippet";

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <StatsBar />
      <WhatWeOffer />
      <WhyChooseUs />
      <FeaturedWork />
      <QuoteCTA />
      <TestimonialsSnippet />
      <AreasCovered />
      <Footer />
    </main>
  );
}
